import React from "react";
import { Platform, TextInput } from "react-native";

const is_android = (Platform.OS === 'android');
export default class TextInputEx extends React.Component {
    static defaultProps = {
        editable: true,
    }

    constructor(props) {
        super(props);
        this.state = {
            editable: !props.editable
        };
    }

    componentDidMount() {
        if (is_android) {
            if (this.props.editable) {
                setTimeout(() => {
                    if (!this._umounted) {
                        this.setState({ editable: true });
                    }
                }, 100);
            }
        }
    }

    componentWillUnmount() {
        this._umounted = true;
    }

    render() {
        if (is_android) {
            // Fix bug: https://github.com/facebook/react-native/issues/20887#issuecomment-416775306
            const { editable } = this.state;
            return (<TextInput {...this.props} editable={editable} />);
        }
        return (<TextInput {...this.props} />);
    }
}
